/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_Disabled_Today_ApprovedInputs */

const vi_chot_so_disabled_today_approved = /** @type {(inputs: Chot_So_Disabled_Today_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôm nay đã có phiếu đã duyệt — không cần chốt lại`)
};

/**

* @param {Chot_So_Disabled_Today_ApprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_disabled_today_approved = /** @type {((inputs?: Chot_So_Disabled_Today_ApprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_Disabled_Today_ApprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_disabled_today_approved(inputs)
});